module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "analytics-container"
  }, [_c('div', {
    staticClass: "row col-xs no-margin no-padding"
  }, [_c('adminPortalAnalyticsFiltersBar', {
    on: {
      "date_filter": _vm.searchAnalytics
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row mt4"
  }, [_c('div', {
    staticClass: "col-xs-12 col-lg-8"
  }, [_c('adminPortalAnalyticsGeneralInfo', {
    attrs: {
      "activeTeachers": _vm.active_teachers,
      "activeStudents": _vm.active_students,
      "numberOnlineActivitiesRun": _vm.number_of_online_activities_run,
      "numberLiveActivitiesCreated": _vm.number_of_live_activities_created,
      "numberLiveActivitiesRun": _vm.number_of_live_activities_run,
      "numberOnlineActivitiesCreated": _vm.number_of_online_activities_created,
      "topicsUsed": _vm.topics_used
    }
  }), _vm._v(" "), _c('adminPortalAnalyticsNumberOfRtsGraph', {
    attrs: {
      "analyticsNumberOfRts": _vm.analytics_number_of_rts
    }
  }), _vm._v(" "), _c('adminPortalAnalyticsTimeSpentOnParlayGraph', {
    attrs: {
      "analyticsTimeSpentOnParlay": _vm.analytics_time_spent_on_parlay
    }
  }), _vm._v(" "), _c('onlineRoundtableEngagement', {
    attrs: {
      "onlineRTEngagement": _vm.online_rt_engagement
    }
  }), _vm._v(" "), _c('liveRoundtableEngagement', {
    attrs: {
      "liveRTEngagement": _vm.live_rt_engagement
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-lg-4"
  }, [_c('adminPortalAnalyticsTables', {
    attrs: {
      "analyticsMostActiveTeachers": _vm.analytics_most_active_teachers,
      "analyticsInactiveTeachers": _vm.analytics_inactive_teachers,
      "analyticsRecentTopicsUsed": _vm.analytics_recent_topics_used,
      "analyticsTopUniversePortfolios": _vm.analytics_top_universe_portfolios
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-19d1d58e!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/analytics/adminPortalAnalytics.vue
// module id = 2167
// module chunks = 61